export default {
    mainContainer: {
        display: "flex",
        flexDirection: "column",
    },
    dropdownRowWrapper:{
        display:"flex",
        justifyContent:"space-between"
    },
    dropdownRow: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },
    downloadUnsubmittedFormsBtn: {
        marginTop: "30px",
        display: 'flex',
    },
    reconciliationFormsNextBtnDiv: {
        alignSelf: "center",
    },
    reconciliationFormsNextBtnDivStyles: {
        padding: "5px 20px",
    },
}